<template>
  <p class="text-3xl mb-4"><slot /></p>
</template>